import { Component, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavData, navItems, navItemsOwner, navItemsPartnerAdmin, navItemsSuperAdmin, navItemsTenants, navItemsVendor } from '../../_nav';
import { Router } from '@angular/router';
import { CommonService } from '../../common/commonService';
import { BaseComponent } from '../../common/base.component';
import { CmsService } from '../../common/cms.service';
import { urlConstant } from '../../constant/urlConstant';
import { LocalstorageService } from '../../services/localstorage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent extends BaseComponent {
  public navItems = [];
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;
  loginUser = this._commonService.getLoggedInUser();
  userShortName = null;
  public username = null;
  role = null;
  subscription;
  navItemsList: any[] = [];
  unAssignedList: any[] = [];
  navItemsDynamic: NavData[] = [];

  constructor(
    cms: CmsService,
    public router: Router,
    public _commonService: CommonService,
    private storage: LocalstorageService,
    private render: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) {
    super(cms);
    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = this._document.body.classList.contains('sidebar-minimized');
    });
    this.element = this._document.body;
    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (!this.loginUser) {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setUserDetail();
    this.subscription = this._commonService.userUpdate.subscribe(x => {
      this.loginUser = this._commonService.getLoggedInUser();
      this.setUserDetail();
    });

    if (!!this.loginUser && this.loginUser.roleId !== null && this.loginUser.roleId !== undefined) {
      this.getNavItems(this.loginUser);
    }
  }

  getNavItems(user) {
    this._commonService.get<any>(
      urlConstant.Admin.getMenuRoleMasterByRole + `?userRoleId=${user.roleId}&partnerId=${user.partnerId}&menuAssignedFor=web`
    ).subscribe((res: any) => {
      if (res.Status === '200') {
        this.navItemsList = res.data['MenuRoleMasterDto'];
        if (this.navItemsList.length > 0) {
          this.setNavData(this.navItemsList);
        }
      } else {
        let nav;
        switch (this.loginUser.roleId) {
          case 222:
            nav = navItems; break;
          case 111:
            nav = navItemsOwner; break;
          case 333:
            nav = navItemsTenants; break;
          case 555:
            nav = navItemsVendor; break;
          case 444:
            nav = navItemsPartnerAdmin; break;
          case 100:
            nav = navItemsSuperAdmin; break;
          default:
            nav = null;
        }
        this.navItems = nav;
      }
    });
  }

  setNavData(navItemsList: any[]) {
    this.navItemsDynamic = [];

    for (let i = 0; i < navItemsList.length; i++) {
      if (navItemsList[i].subMenuList.length > 0) {
        this.navItemsDynamic.push({
          name: navItemsList[i].menuName,
          icon: navItemsList[i].menuIcon,
          children: [],
        });

        for (let j = 0; j < navItemsList[i].subMenuList.length; j++) {
          if (navItemsList[i].menuId === navItemsList[i].subMenuList[j].menuId) {
            if (this.loginUser.roleId === 444 && navItemsList[i].subMenuList[j].subMenuName === "Task") {
              navItemsList[i].subMenuList[j].subMenuUrl = "/admin/dashboard/view-all/task-reminder/admin-task";
            }
            this.navItemsDynamic[i].children.push({
              name: navItemsList[i].subMenuList[j].subMenuName,
              url: navItemsList[i].subMenuList[j].subMenuUrl,
              icon: navItemsList[i].subMenuList[j].subMenuIcon,
            });
          }
        }
      } else {
        this.navItemsDynamic.push({
          name: navItemsList[i].menuName,
          url: navItemsList[i].menuUrl,
          icon: navItemsList[i].menuIcon,
        });
      }
    }

    this.navItems = this.navItemsDynamic;

    // Auto-close dropdowns after DOM update
    setTimeout(() => {
      this.closeSidebarDropdowns();
    }, 200);
  }
closeSidebarDropdowns() {
  const openDropdowns = this._document.querySelectorAll('.nav-dropdown.open');
  openDropdowns.forEach(dropdown => {
    this.render.removeClass(dropdown, 'open');
  });
}


  setUserDetail() {
    if (this.loginUser && this.loginUser.roles.length > 0) {
      this.role = this.loginUser.roles[0].name;
    }

    this.username = this.loginUser.firstName + (this.loginUser.lastName ? ' ' + this.loginUser.lastName : ' ');
    const matches = this.username.match(/\b(\w)/g);
    this.userShortName = matches.join('');
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.changes.disconnect();
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    this.router.navigate(['/login']);
  }

  clearProperty() {
    this.storage.clearProperty();
  }
}
